import { useState } from "react";
import { errorMessage, post } from "../api";
import { Alert, Button } from "./ui";

/** A photo for the clinic's website (a headshot, a service's photo): upload, see it, or take it off. */
export function PhotoInput({ label, url, onChange }: { label: string; url: string | null; onChange: (key: string | null) => void }) {
  const [preview, setPreview] = useState<string | null>(url);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const upload = async (file: File) => {
    setBusy(true);
    setError(null);
    try {
      const up = await post<{ key: string; url: string; headers: Record<string, string> }>("/api/website/photo-upload", { contentType: file.type });
      const res = await fetch(up.url, { method: "PUT", headers: up.headers, body: file });
      if (!res.ok) throw new Error("The photo couldn't be uploaded. Try again.");
      setPreview(URL.createObjectURL(file));
      onChange(up.key);
    } catch (e) {
      setError(e);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-col gap-2 text-sm">
      <span className="font-semibold text-ink-soft">{label}</span>
      <div className="flex items-center gap-3">
        {preview ? <img src={preview} alt="" className="size-20 rounded-lg border border-line object-cover" /> : <div className="grid size-20 place-items-center rounded-lg border border-dashed border-line text-xs text-muted">No photo</div>}
        <div className="flex flex-col items-start gap-1">
          <label className="cursor-pointer rounded-[var(--radius-control)] border border-line bg-white px-3 py-1.5 font-semibold hover:border-ink-soft">
            {busy ? "Uploading…" : preview ? "Replace" : "Upload a photo"}
            <input type="file" accept="image/jpeg,image/png,image/webp" className="sr-only" disabled={busy} onChange={(e) => e.target.files?.[0] && upload(e.target.files[0])} />
          </label>
          {preview && (
            <Button
              variant="quiet"
              onClick={() => {
                setPreview(null);
                onChange(null);
              }}
            >
              Remove
            </Button>
          )}
        </div>
      </div>
      {error != null && <Alert>{errorMessage(error)}</Alert>}
    </div>
  );
}
